import { imgs } from "../../assets/imgs";
import { svgs } from "../../assets/svgs";
import { Slides } from "../Slides";
import { VCLogos } from "./VCLogos";

export const Hero = () => {
    const heroImgs = [
        imgs.home.slide1,
        imgs.home.slide2,
        imgs.home.slide3,
        imgs.home.slide4,
    ]

    return (
        <div className='hero'>
            <section>
                {svgs.eventLogo}
                <h2>December 12<sup>th</sup> & 13<sup>th</sup>, 2023</h2>
                <h3>Hilton | Boston Dedham, MA</h3>
            </section>
            <section>
                <Slides imgs={heroImgs}/>
                {/* <img src={imgs.home.hero} alt="" /> */}
                    {/* <div class="slides">
                        {heroImgs.map(img =>
                            <img src={img} alt="" />
                        )}
                    </div> */}
            </section>
            <div>
                <VCLogos />
            </div>
        </div>
    );
};